import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 22H3V20H21V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.1553 10.2227H10.8447L12 7.71973L13.1553 10.2227Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 18H1V2H23V18ZM11.0527 5L6.67285 14.4893L8.48926 15.3271L9.92188 12.2227H14.0781L15.5107 15.3271L17.3271 14.4893L12.9473 5H11.0527Z"}}]};

const AutomationFilled = Vue.extend<IconProps>({
  name: 'AutomationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'automation-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AutomationFilled;
